import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { Method } from '@/fetch/core/util';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Modal, message } from 'antd';
import classNames from 'classnames';
import { getClstag } from '@/utils/util';
import { PncTaskType, VehicleScheduleStateEnum } from '@/utils/constant';
const AsArrived = (props: {
  vehicleName: string;
  cockpitNumber: string;
  takeOverBySelf: boolean;
  pncTaskType?: PncTaskType;
  scheduleState?: VehicleScheduleStateEnum;
}) => {
  const userName = useSelector(
    (state: RootState) => state.login?.userInfo?.userName
  );
  const cockpitMode = useSelector(
    (state: RootState) => state.newCommon?.cockpitMode
  );
  const useable =
    props.takeOverBySelf &&
    (props.scheduleState === VehicleScheduleStateEnum.SETOUT ||
      props.scheduleState === VehicleScheduleStateEnum.RETURN ||
      props.pncTaskType === PncTaskType.ACTIVE);
  const handleArrived = () => {
    const { cockpitNumber, vehicleName } = props;
    if (!userName || !cockpitNumber || !vehicleName) {
      return;
    }
    const requestData: RequestOptions = {
      path: '/monitor/web/drive/command/send/as-arrived',
      method: Method.POST,
      body: {
        cockpitNumber,
        vehicleName,
        cockpitUserName: userName,
      },
    };
    request(requestData).then((res: any) => {
      if (res.code == HttpStatusCode.Success) {
        message.success('指令下发成功');
      } else {
        message.warning(res.message || '指令下发失败');
      }
    });
  };

  return (
    <>
      <li
        className={classNames('btn-item asArrived', {
          'asArrived-disabled': !useable,
        })}
        onClick={() => {
          if (!useable) {
            return;
          }
          Modal.confirm({
            content: '是否确认视同到达？',
            onOk: handleArrived,
          });
        }}
        clstag={
          props.takeOverBySelf
            ? getClstag(cockpitMode, 'SinglePgae_AsArrived')
            : ''
        }
      >
        <i>视同到达</i>
      </li>
    </>
  );
};

export default React.memo(AsArrived);
